import React from 'react';
import { Redirect } from 'react-router';

import { SpacesSiteUrls } from '~src/spacesPlatform/components/spaceComponents/SpacesSiteUrls';

import { RouterError } from '../../bootstrap/routerHelpers/RouterError';
import { Favorites } from '../../favorites/resources/Favorites';
import { FlowDetailInfo } from '../models/FlowInfo';
import { Flows } from '../resources/Flows';

export interface FlowSpaceFavoriteRedirectProps {
  readonly flowId: string;
  readonly urls: SpacesSiteUrls;
}

type FlowStatus = 'unfetched' | 'fetched' | 'error';

export const FlowSpaceFavoriteRedirect: React.FunctionComponent<FlowSpaceFavoriteRedirectProps> = props => {
  const [ flowStatus, setFlowStatus ] = React.useState<FlowStatus>('unfetched');

  React.useEffect(
    () => {
      let didCancel = false;

      fetchFlow(props.flowId)
        .then(() => !didCancel && setFlowStatus('fetched'))
        .catch(() => {
          removeFavoriteFlow(props.flowId);
          !didCancel && setFlowStatus('error');
        });

      return () => didCancel = true;
    },
    // This deps array was noncompliant before we enabled the lint rule. If you’re here, please consider fixing it! See TFS 1257824
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  if (flowStatus === 'unfetched') {
    return null;
  } else if (flowStatus === 'fetched') {
    return <Redirect to={props.urls.flowPath(props.flowId)}/>;
  } else {
    return <RouterError errorType={'flow-removed-favorite'} urls={props.urls} />;
  }
};

async function fetchFlow(flowId: string): Promise<FlowDetailInfo> {
  return Flows.getById(flowId);
}

function removeFavoriteFlow(flowId: string) {
  Favorites.remove(flowId, 'flow');
}
